import axios from "axios";
import API_URL from "../Config";

export async function fetchDepartmentAttachment(file) {
  const response = await axios.get(`${API_URL}/api/permit/department/attachments/download/${encodeURIComponent(file.id)}`, {
    headers: { Authorization: localStorage.getItem("authKey") }, responseType: "blob",
  });
  const extension = String(file.original_filename || "").split(".").pop().toLowerCase();
  const types = { pdf: "application/pdf", png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg", gif: "image/gif", webp: "image/webp", txt: "text/plain", csv: "text/plain" };
  const contentType = String(response.data?.type || response.headers?.["content-type"] || "").split(";")[0].toLowerCase();
  const safeType = Object.values(types).includes(contentType) ? contentType : types[extension] || "application/octet-stream";
  return new Blob([response.data], { type: safeType });
}

export async function viewDepartmentAttachment(file) {
  // Open during the click so fetching the protected file does not trigger popup blocking.
  const tab = window.open("", "_blank");
  if (!tab) throw new Error("Allow pop-ups for this site to view documents in a new tab.");
  tab.opener = null;
  tab.document.title = file.original_filename || "Document preview";
  tab.document.body.textContent = "Loading document…";
  let url;
  try {
    const blob = await fetchDepartmentAttachment(file);
    if (tab.closed) return;
    url = URL.createObjectURL(blob);
    tab.location.replace(url);
    // Give the browser's document viewer time to load before releasing the blob.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    if (url) URL.revokeObjectURL(url);
    if (!tab.closed) tab.close();
    throw error;
  }
}
